var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusSquareFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "add_1_",
    "data-name": "add (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41505",
    "data-name": "Group 41505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41504",
    "data-name": "Group 41504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37101",
    "data-name": "Path 37101",
    d: "M17.25,0H3.75A3.754,3.754,0,0,0,0,3.75v13.5A3.754,3.754,0,0,0,3.75,21h13.5A3.754,3.754,0,0,0,21,17.25V3.75A3.754,3.754,0,0,0,17.25,0Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41507",
    "data-name": "Group 41507",
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41506",
    "data-name": "Group 41506"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37102",
    "data-name": "Path 37102",
    d: "M144.783,140.283h-3v-3a.75.75,0,0,0-1.5,0v3h-3a.75.75,0,1,0,0,1.5h3v3a.75.75,0,1,0,1.5,0v-3h3a.75.75,0,1,0,0-1.5Z",
    transform: "translate(-136.533 -136.533)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSquareFilled);
export default __webpack_public_path__ + "static/media/plus-square-filled.cb1da55c4ebb63682f2945c0f6499808.svg";
export { ForwardRef as ReactComponent };